var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaximizeMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 8,
    fill: "#1E364F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1656 27.1538V31.7054L23.2156 25.6555C23.3213 25.5497 23.4929 25.5497 23.5986 25.6555L25.454 27.5108C25.5597 27.6165 25.5597 27.7881 25.454 27.8938L19.4039 33.9438H23.9557C24.1052 33.9438 24.2265 34.065 24.2265 34.2146V36.8385C24.2265 36.988 24.1052 37.1093 23.9557 37.1093L14.2709 37.1092C14.1214 37.1092 14.0001 36.9879 14.0001 36.8383L14 27.1538C14 27.0042 14.1213 26.8829 14.2708 26.8829H16.8947C17.0443 26.8829 17.1656 27.0042 17.1656 27.1538Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7065 17.1654H27.1548C27.0052 17.1654 26.8839 17.0441 26.8839 16.8946V14.2707C26.8839 14.1151 27.0083 13.9935 27.1787 14.001L36.8395 14.0011C36.9951 14.0011 37.1167 14.1243 37.1093 14.2948L37.1094 23.9554C37.1094 24.1049 36.9891 24.2262 36.8396 24.2262H34.2157C34.0661 24.2262 33.9449 24.1049 33.9449 23.9554V19.4038L27.8948 25.4537C27.7891 25.5594 27.6175 25.5594 27.5118 25.4537L25.6564 23.5984C25.5507 23.4927 25.5507 23.3211 25.6564 23.2154L31.7065 17.1654Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximizeMode);
export default __webpack_public_path__ + "static/media/maximizeMode.79175bcf205facb4e6b6861d5a452ffc.svg";
export { ForwardRef as ReactComponent };